var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4231",
    "data-name": "Rectangle 4231",
    width: 26,
    height: 26,
    transform: "translate(682 474)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_02",
    "data-name": 2,
    transform: "translate(-682 -474)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "message-question-02",
    d: "M18.417,2.633H7.583A5.118,5.118,0,0,0,2.167,8.049v6.5a5.118,5.118,0,0,0,5.417,5.417v2.307a1.077,1.077,0,0,0,1.679.9l4.821-3.207h4.333a5.118,5.118,0,0,0,5.417-5.417v-6.5A5.118,5.118,0,0,0,18.417,2.633ZM13,15.817A.813.813,0,1,1,13.813,15,.811.811,0,0,1,13,15.817Zm1.365-4.5c-.422.282-.552.466-.552.769v.227a.812.812,0,0,1-1.625,0V12.09a2.521,2.521,0,0,1,1.267-2.113c.4-.271.531-.455.531-.737a.986.986,0,0,0-1.972,0,.813.813,0,0,1-1.625,0,2.611,2.611,0,0,1,5.222,0A2.485,2.485,0,0,1,14.365,11.321Z",
    transform: "translate(681.833 474.367)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpActive);
export default __webpack_public_path__ + "static/media/help_active.3d78be13d89588df0f56c4770ac551f1.svg";
export { ForwardRef as ReactComponent };